import getInfo from './get'

export default {
    getInfo,
}
